import { useEffect, useRef, useState } from "react";

import styles from "@/styles/components/input.module.scss";

import classNames from "classnames/bind";
const css = classNames.bind(styles);

export const Input = ({
  type = "text",
  onBlur,
  onFocus,
  autoFocus,
  onChange,
  value,
  disabled,
  name,
  readOnly,
  id,
  placeholder,
  className,
  design = "default",
  maxLength,
  openFade,
  capitalize,
}) => {
  const ref = useRef(null);
  const [open, setOpen] = useState(false);

  const onEnter = (e) => {
    if (e.key === "Enter") e.target.blur();
  };

  useEffect(() => {
    setOpen(openFade);
  }, [openFade]);

  return (
    <>
      <div className={styles.inputContainer}>
        <input
          ref={(el) => (ref.current = el)}
          id={id}
          type={type}
          name={name}
          value={value}
          onChange={onChange}
          onFocus={() => {
            setOpen(true);
            onFocus && onFocus();
          }}
          autoComplete="off"
          disabled={disabled}
          autoFocus={autoFocus}
          placeholder={placeholder}
          className={css({
            [className]: className,
            [design]: true,
            readOnly: readOnly,
            capitalize: capitalize,
          })}
          onKeyUp={onEnter}
          maxLength={maxLength}
        />
      </div>
    </>
  );
};
